<ng-container *ngIf="isAuthenticating">
  <h4 class="text-center pt-3">Authenticating...</h4>
  <app-loader class="pt-2"></app-loader>
</ng-container>
<!-- Login -->
<form
  [formGroup]="form"
  (submit)="login()"
  novalidate
  *ngIf="
    user &&
    !mustChangePwd &&
    !showForgotPwd &&
    !isAuthenticating &&
    !showForgotUsername
  "
>
@if(!templateForPermitForm){
  <div class="form-group">
    <label for="inputLoginUsername" class="bmd-label-floating">Username</label>
    <input
      type="text"
      id="inputLoginUsername"
      class="form-control"
      [(ngModel)]="user.userName"
      formControlName="userName"
      name="inputLoginUsername"
    />
    <wm-control-message [control]="form.controls.userName"></wm-control-message>
  </div>

  <div class="form-group">
    <label for="inputLoginPassword" class="bmd-label-floating">Password</label>
    <input
      type="password"
      id="inputLoginPassword"
      class="form-control"
      [(ngModel)]="user.password"
      formControlName="password"
      name="inputLoginPassword"
    />
    <wm-control-message [control]="form.controls.password"></wm-control-message>
  </div>
  <div class="text-danger">{{ statusMsg }}</div>

  <div class="mt-5">
    <button type="button" (click)="forgotPwd()" class="btn btn-default">
      Forgot Password
    </button>
    <button type="button" (click)="forgotUsername()" class="btn btn-default">
      Forgot Username
    </button>
    <button
      class="btn btn-raised btn-primary float-right"
      [disabled]="!form.valid || saving"
    >
      <span *ngIf="!saving">SIGN IN</span>

      <span *ngIf="saving">
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        SIGN IN...
      </span>
    </button>
  </div>
  <div class="card-footer">
    <a
      id="lnkUserPrivacyPolicy"
      title="Opens in a new tab"
      href="https://www.schneidergis.com/privacypolicy"
      target="_blank"
      >User Privacy Policy</a
    >
    <br />
    <a
      id="lnkGDPRPrivacyPolicy"
      title="Opens in a new tab"
      href="https://www.schneidergis.com/gdprprivacynotice"
      target="_blank"
      >GDPR Privacy Notice</a
    >
  </div>
}
@else{
  <div class="form-group" style="padding-top: 0 !important;">
    <wm-common-textfield
      formControlName="userName"
      name="inputLoginUsername"
      [data]="{ label: 'Username', value: user.userName,
     }"
     (valueChange)="user.userName = $event"
      >
    </wm-common-textfield>
    <wm-control-message [control]="form.controls.userName"></wm-control-message>
    </div>
    <div class="form-group" style="padding-top: 0 !important;">
    <wm-common-textfield
      formControlName="password"
      name="inputLoginPassword"
      [data]="{ label: 'Password', type: 'password', value: user.password }"
      (valueChange)="user.password = $event"
      >
    </wm-common-textfield>
    <wm-control-message [control]="form.controls.password"></wm-control-message>
    </div>

    <wm-common-text  [data]="{ text: statusMsg, color: 'darkred' }"  class="text-danger"></wm-common-text>

    <div class="mt-2 mb-5">

 <div class="mb-1">
  <wm-common-button
    [data]="{ text: 'Forgot Password', onClick: forgotPwd.bind(this) }"
  >
  </wm-common-button>
</div>

<div class="mb-1">
  <wm-common-button
    [data]="{ text: 'Forgot Username', onClick: forgotUsername.bind(this) }"
  >
  </wm-common-button>
</div>
  <wm-common-button 
      class="float-right cred-btn"
      [data]="{ text: saving ? 'SIGN IN...' : 'SIGN IN', type: 'submit' }" 
      [disabled]="!form.valid || saving">
    </wm-common-button>

  </div>
    <div class="card-footer">
    <a
      id="lnkUserPrivacyPolicy"
      style="color: rgba(33, 150, 243, 1) !important;"
      title="Opens in a new tab"
      href="https://www.schneidergis.com/privacypolicy"
      target="_blank"
      >User Privacy Policy</a
    >
    <br />
    <a
      id="lnkGDPRPrivacyPolicy"
      style="color: rgba(33, 150, 243, 1) !important;"
      title="Opens in a new tab"
      href="https://www.schneidergis.com/gdprprivacynotice"
      target="_blank"
      >GDPR Privacy Notice</a
    >
  </div>
}
</form>

<!-- Must Change Password -->
<form
  *ngIf="mustChangePwd"
  [formGroup]="changePwdForm"
  (submit)="changePwd()"
  novalidate
>
@if(!templateForPermitForm){
  <div class="form-group">
    <label for="oldPassword" class="bmd-label-floating">Old Password</label>
    <input
      type="password"
      class="form-control"
      formControlName="oldPassword"
      [(ngModel)]="oldPassword"
      name="oldPassword"
    />
    <wm-control-message
      [control]="form.controls.oldPassword"
    ></wm-control-message>
  </div>
  <div class="form-group">
    <label for="newPassword" class="bmd-label-floating">New Password</label>
    <input
      type="password"
      [(ngModel)]="newPassword"
      formControlName="newPassword"
      class="form-control"
      name="newPassword"
    />
    <wm-control-message
      [control]="form.controls.newPassword"
    ></wm-control-message>
  </div>
  <div class="form-group">
    <label for="confirmPassword" class="bmd-label-floating"
      >Confirm Password</label
    >
    <input
      type="password"
      [(ngModel)]="confirmPassword"
      formControlName="confirmPassword"
      class="form-control"
      name="confirmPassword"
    />
    <wm-control-message
      [control]="form.controls.confirmPassword"
    ></wm-control-message>
  </div>

  <div class="text-danger">{{ statusMsg }}</div>

  <div class="mt-5">
    <button type="button" class="btn btn-default" (click)="cancelChangePwd()">
      Cancel
    </button>
    <button
      type="submit"
      class="btn btn-primary btn-raised float-right"
      [disabled]="!changePwdForm.valid"
    >
      Change Password
    </button>
  </div>
}
@else{
  <div class="form-group" style="padding-top: 0 !important;">
    <wm-common-textfield
      formControlName="oldPassword"
      name="oldPassword"
      [data]="{ label: 'Old Password', type: 'password', value: oldPassword,
     }"
     (valueChange)="oldPassword = $event"
      >
    </wm-common-textfield>
    <wm-control-message [control]="form.controls.oldPassword"></wm-control-message>
    </div>
    <div class="form-group" style="padding-top: 0 !important;">
    <wm-common-textfield
      formControlName="newPassword"
      name="newPassword"
      [data]="{ label: 'New Password', type: 'password', value: newPassword }"
      (valueChange)="newPassword = $event"
      >
    </wm-common-textfield>
    <wm-control-message [control]="form.controls.newPassword"></wm-control-message>
    </div>

    <div class="form-group" style="padding-top: 0 !important;">
    <wm-common-textfield
      formControlName="confirmPassword"
      name="confirmPassword"
      [data]="{ label: 'Confirm Password', type: 'password', value: confirmPassword }"
      (valueChange)="confirmPassword = $event"
      >
    </wm-common-textfield>
    <wm-control-message [control]="form.controls.confirmPassword"></wm-control-message>
    </div>

    <wm-common-text  [data]="{ text: statusMsg, color: 'darkred' }"  class="text-danger"></wm-common-text>

    <div class="mt-1">
       <wm-common-button
    [data]="{ text: 'Cancel', onClick: cancelChangePwd.bind(this) }"
  >
  </wm-common-button>

  <wm-common-button 
      class="float-right cred-btn"
      [data]="{ text: 'Change Password', type: 'submit' }" 
      [disabled]="!changePwdForm.valid">
    </wm-common-button>

  </div>

}
</form>

<!-- Forgot Password -->
<form
  *ngIf="showForgotPwd"
  [formGroup]="resetPwdForm"
  (submit)="resetPwd()"
  novalidate
>
@if(!templateForPermitForm){
  <div class="form-group">
    <label for="inputForgotPwdUsername" class="bmd-label-floating"
      >Username</label
    >
    <input
      type="text"
      id="inputForgotPwdUsername"
      class="form-control"
      [(ngModel)]="resetPwdUsername"
      formControlName="username"
      name="inputForgotPwdUsername"
    />
    <wm-control-message
      [control]="resetPwdForm.controls.username"
    ></wm-control-message>
  </div>

  <div class="text-danger">{{ statusMsg }}</div>

  <div class="mt-5">
    <button type="button" class="btn btn-default" (click)="cancelResetPwd()">
      Cancel
    </button>
    <button
      type="submit"
      class="btn btn-primary btn-raised float-right"
      [disabled]="!resetPwdForm.valid"
    >
      Reset Password
    </button>
  </div>
}
@else{
    <div class="form-group" style="padding-top: 0 !important;">
    <wm-common-textfield
      formControlName="username"
      name="inputForgotPwdUsername"
      [data]="{ label: 'Username', value: resetPwdUsername,
     }"
     (valueChange)="resetPwdUsername = $event"
      >
    </wm-common-textfield>
    </div>

    <wm-common-text [data]="{ text: statusMsg, color: 'darkred' }"  class="text-danger"></wm-common-text>

      <div class="mt-1">
       <wm-common-button
    [data]="{ text: 'Cancel', onClick: cancelResetPwd.bind(this) }"
  >
  </wm-common-button>

  <wm-common-button 
      class="float-right cred-btn"
      [data]="{ text: 'Reset Password', type: 'submit' }" 
      [disabled]="!resetPwdForm.valid">
    </wm-common-button>

  </div>
}
</form>
<!-- Forgot Username -->
<form
  *ngIf="showForgotUsername"
  [formGroup]="sendUsernamesEmailForm"
  (submit)="sendUsernamesEmailSubmit()"
  novalidate
>
@if(!templateForPermitForm){
  <div class="form-group">
    <label for="inputForgotUsernameEmail" class="bmd-label-floating"
      >Email Address</label
    >
    <input
      type="email"
      id="inputForgotUsernameEmail"
      class="form-control"
      [(ngModel)]="sendUsernamesEmail"
      formControlName="email"
      name="inputForgotUsernameEmail"
    />
    <wm-control-message
      [control]="sendUsernamesEmailForm.controls.email"
    ></wm-control-message>
    <wm-error>
      <div
        *ngIf="
          !sendUsernamesEmailForm.controls.email.valid &&
          (sendUsernamesEmailForm.controls.email.dirty ||
            sendUsernamesEmailForm.controls.email.touched)
        "
        class="text-red"
      >
        <div *ngIf="sendUsernamesEmailForm.controls.email.errors.invalidMsg">
          {{ sendUsernamesEmailForm.controls.email.errors.invalidMsg }}
        </div>
      </div>
    </wm-error>
  </div>

  <div class="text-danger">{{ statusMsg }}</div>

  <div class="mt-5">
    <button
      type="button"
      class="btn btn-default"
      (click)="cancelResetUsername()"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="btn btn-primary btn-raised float-right"
      [disabled]="!sendUsernamesEmailForm.valid"
    >
      Send Username
    </button>
  </div>
}
@else{

  <div class="form-group" style="padding-top: 0 !important;">
    <wm-common-textfield
      formControlName="email"
      name="inputForgotUsernameEmail"
      [data]="{ label: 'Email Address', value: sendUsernamesEmail,
     }"
     (valueChange)="sendUsernamesEmail = $event"
      >
    </wm-common-textfield>
       <wm-control-message
      [control]="sendUsernamesEmailForm.controls.email"
    ></wm-control-message>
    </div>

    <wm-common-text  [data]="{ text: statusMsg, color: 'darkred' }"  class="text-danger"></wm-common-text>

        <div class="mt-1">
       <wm-common-button
    [data]="{ text: 'Cancel', onClick: cancelResetUsername.bind(this) }"
  >
  </wm-common-button>

  <wm-common-button 
      class="float-right cred-btn"
      [data]="{ text: 'Send Username', type: 'submit' }" 
      [disabled]="!sendUsernamesEmailForm.valid">
    </wm-common-button>

  </div>
}
</form>
